import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import ParentModal from "../parentModal";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import {
  names,
  parent,
} from "../../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../../core/common/commonSelect";
import TooltipOption from "../../../../core/common/tooltipOption";
import UserService from "../../../network/services/UserService";
import { getUser } from "../../../network/auth/Auth";
import { Modal, Toast } from 'react-bootstrap'
import Select, { GroupBase } from "react-select";

import { getFirestore, collection, doc, setDoc, addDoc, updateDoc } from 'firebase/firestore'; // pour la version 9 et ultérieures
import { firestore } from '../../../../firebase'


const ParentGrid = () => {
  const [show, setShow] = useState(false);
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const navigation = useNavigate()
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const handleClose = () => {
    setShow(false);
  };



  interface Option {
    id: any;
    name: any;
    phone: any;
    email: any;
    avatar: any;
    students: any;
    relation: any;
    partner_id: any;

  }


  interface Option2 {
    name: any;
    phone: any;
    email: any;
    id: any;
    rfid_code: any;
    active: any;
    first_name: any;
    last_name: any;
    course_detail_ids: any;
    blood_group: any;
    gender: any;
    nationality: any;
    partner_id: any;
    avatar: any;
    students: any;
    relation: any;
  }












  interface SudentData {
    id: any;
    rfid_code: any;
    active: any;
    avatar: any;
    first_name: any;
    last_name: any;
    course_detail_ids: any;
    blood_group: any;
    gender: any;
    nationality: any
  }

  interface Option {
    id: any;
    name: any;
  }


  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal0, setShowModal0] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const [relationShips, setRelationShips] = useState<Option[]>([]);

  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    email: '',
    phone: '',
    password: '',
    relationship_id: '',
    students_ids: [],
  });



  const [selectedId, setSelectedId] = useState<any>();

  const handleClose0 = () => setShowModal0(false);
  const handleShow0 = () => setShowModal0(true);

  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };


  const getAllARelation = async () => {
    await UserService.getRelationship((response: any) => {
      if (response?.data && response?.success) {
        setRelationShips(response.data)
      }
    })
  }




  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    relationship_id: '',
    students_ids: [],
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  const handleInputChangeEdite = (e: any) => {
    console.log(e.target)
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (e: any) => {
    const { name, value } = e.target;
    console.log(`Changed ${name} to ${value}`); // Debugging

    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: {
        id: value,
        // name: branches.find((branch: any) => branch.id === value)?.name || '' // Assurez-vous que `name` est mis à jour correctement
      }
    }));
  };

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    const studentsAsOptions: OptionType[] = record.students.map((student: any) => ({
      value: student.id,
      label: student.first_name + " " + student.last_name,
    }));
    setMultiSubject(studentsAsOptions)
    console.log(record)
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };

  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);


  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        students_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        students_ids: [],
      }));
    }
  };



  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };






  interface OptionType {
    label: any;
    value: number;
  }
  const [students, setStudents] = useState<OptionType[]>([]);





  const [parentStudents, setParentStudents] = useState<Option2>();
  const [parents, setParents] = useState<Option[]>([]);

  const [branch, setBranch] = useState<any>();
  const branches = [];




  const showStudents = (studens: any) => {
    setShow(true)
    setParentStudents(studens)
  }

  const navigeStudentDetails = (student: any) => {
    navigation(routes.studentDetail, { state: { student: student } })
  }


  const [drivers, setDrivers] = useState<any>([]);
  const getAllDrivers = () => {


    UserService.getDrivers((response: any) => {
      console.log(response.data)

      if (response?.success === true) {
        setDrivers(response.data)
        console.log(response.data)
      }
    })
  }

  useEffect(() => {
    getAllDrivers()
  }, [])


  const handleSubmit = () => {
    setIsLoading(true)
    const request_data = {

    };


    UserService.verifierAccount(selectedId?.user_id, request_data, async (response: any) => {
      console.log(response)
      if (response.success) {

        try {
          // Référence à l'utilisateur dans la collection 'users'
          const userRef = doc(collection(firestore, 'drivers'), selectedId?.id + "");

          // Mettre à jour le champ 'is_verified' dans Firestore
          await updateDoc(userRef, {
            is_verified: true,
          });

          console.log('User successfully verified and updated in Firebase.');

          setIsLoading(false);
          setSuccessMessage('User verified successfully and updated in Firebase.');
          setShowSuccessToast(true);
          setShowModal(false);
          getAllDrivers(); // Récupérer tous les utilisateurs mis à jour
        } catch (error) {
          console.error('Error updating user in Firebase: ', error);
          setErrorMessage('Failed to update user in Firebase.');
          setShowDangerToast(true);
          setIsLoading(false);
        }
      } else {

        setErrorMessage(response?.message)
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };


  const handleSubmit2 = () => {
    setIsLoading(true)
    const request_data = {

    };


    UserService.unVerifierAccount(selectedId?.user_id, request_data, async (response: any) => {
      console.log(response)
      if (response.success) {

        try {
          // Référence à l'utilisateur dans la collection 'users'
          const userRef = doc(collection(firestore, 'drivers'), selectedId?.id + "");

          // Mettre à jour le champ 'is_verified' dans Firestore
          await updateDoc(userRef, {
            is_verified: false,
          });

          console.log('User successfully verified and updated in Firebase.');

          setIsLoading(false);
          setSuccessMessage('User verified successfully and updated in Firebase.');
          setShowSuccessToast(true);
          setShowModal(false);
          getAllDrivers(); // Récupérer tous les utilisateurs mis à jour
        } catch (error) {
          console.error('Error updating user in Firebase: ', error);
          setErrorMessage('Failed to update user in Firebase.');
          setShowDangerToast(true);
          setIsLoading(false);
        }
      } else {

        setErrorMessage(response?.message)
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };



  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content content-two">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Drivers</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Peoples</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Drivers
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              <div className="mb-2">
                <a

                  className="btn btn-success d-flex align-items-center"
                  onClick={handleShow2}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Drivers
                </a>
              </div>
              <div className="mb-2 mx-2">
                <a

                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleShow0}
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Drivers
                </a>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="bg-white p-3 border rounded-1 d-flex align-items-center justify-content-between flex-wrap mb-4 pb-0">
            <h4 className="mb-3">Drivers Grid</h4>
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-icon-start mb-3 me-2 position-relative">
                <PredefinedDateRanges />
              </div>
              <div className="dropdown mb-3 me-2">
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                >
                  <i className="ti ti-filter me-2" />
                  Filter
                </Link>
                <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                  <form>
                    <div className="d-flex align-items-center border-bottom p-3">
                      <h4>Filter</h4>
                    </div>
                    <div className="p-3 pb-0 border-bottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Parent</label>
                            <CommonSelect
                              className="select"
                              options={parent}
                              defaultValue={parent[0]}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">Child</label>
                            <CommonSelect
                              className="select"
                              options={names}
                              defaultValue={names[0]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-3 d-flex align-items-center justify-content-end">
                      <Link to="#" className="btn btn-light me-3">
                        Reset
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-primary"
                        onClick={handleApplyClick}
                      >
                        Apply
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                <Link
                  to={routes.parentList}
                  className=" btn btn-icon btn-sm me-1 bg-light primary-hover"
                >
                  <i className="ti ti-list-tree" />
                </Link>
                <Link
                  to={routes.parentGrid}
                  className=" active btn btn-icon btn-sm  primary-hover"
                >
                  <i className="ti ti-grid-dots" />
                </Link>
              </div>
              <div className="dropdown mb-3">
                <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                  <i className="ti ti-sort-ascending-2 me-2" />
                  {branch}
                </Link>
                <ul className="dropdown-menu p-3">
                  <li >
                    <a className="dropdown-item rounded-1" >
                      All
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            {drivers && drivers?.map((item: any, index: any) =>
            (<div className="col-xl-4 col-md-6 d-flex" key={index}>
              <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <Link
                    to="#"
                    className="link-primary"
                    onClick={() => showStudents(item)}
                  >
                    {item?.phone}
                  </Link>
                  <div className="d-flex align-items-center">
                    {item?.user?.is_verified ? (
                      <span className="badge badge-soft-success d-inline-flex align-items-center me-1">
                        <i className="ti ti-circle-filled fs-5 me-1" />
                        verify
                      </span>
                    ) : (
                      <span className="badge badge-soft-danger d-inline-flex align-items-center me-1">
                        <i className="ti ti-circle-filled fs-5 me-1" />
                        Not verified
                      </span>
                    )
                    }
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="ti ti-dots-vertical fs-14" />
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-right p-3">

                        <li>
                          <Link
                            className="dropdown-item rounded-1"
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-modal"
                            onClick={() => { setSelectedId(item); console.log(item) }}
                          >
                            <i className="ti ti-check me-2" />
                            verifier compte
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="bg-light-300 rounded-2 p-3 mb-3">
                    <div className="d-flex align-items-center">
                      <Link
                        to="#"
                        onClick={() => setShow(true)}
                        className="avatar avatar-lg flex-shrink-0"
                      >
                        <img
                          /*  src={`data:image/png;base64,${item.avatar}`} */
                          src={` https://img.freepik.com/premium-vector/limousine-driver-avatar_106788-330.jpg`}
                          className="img-fluid rounded-circle"
                          alt="img"
                        />
                      </Link>
                      <div className="ms-2">
                        <h6 className="text-dark text-truncate mb-0">
                          <Link to="#" onClick={() => showStudents(item)}>{item?.name}</Link>
                        </h6>
                        <p>{item?.phone}</p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between gx-2">

                    <div>
                      <p className="mb-0">Phone</p>
                      <p className="text-dark">{item?.phone}</p>
                    </div>
                    <div>
                      <p className="mb-0">Balance</p>
                      <span className="badge badge-soft-primary d-inline-flex align-items-center me-1">
                        <i className="ti ti-money fs-5 me-1" />
                        {item?.balance} Fcfa
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
                    >
                      <i className="ti ti-brand-hipchat" />
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle  p-0 me-2"
                    >
                      <i className="ti ti-phone" />
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
                    >
                      <i className="ti ti-mail" />
                    </Link>
                  </div>
                  <a

                    // onClick={() => navigeStudentDetails(item)}
                    className="btn btn-light btn-sm fw-semibold"
                  >
                    View
                  </a>
                </div>
              </div>
            </div>)
            )}


            <div className="col-md-12">
              <div className="load-more text-center">
                {
                  isLoading ? (<Link to="#" className="btn btn-primary">
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Load More ...
                  </Link>) : (<Link to="#" className="btn btn-primary">
                    <i className="ti ti-loader-3 me-2" />
                    Load More
                  </Link>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-check" />
                </span>
                <h4>Verifier le compte</h4>
                <p>
                  {selectedId?.user?.is_verified === 0 ?
                    ("Vous souhaitez verifier ce compte.") : ("Vous souhaitez retirer la verification sur ce compte.")}
                </p>
                <div className="d-flex justify-content-center">
                  <>
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Fermer
                    </Link>
                    {
                      selectedId?.user?.is_verified === 0 ?
                        (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit}>
                          Oui, Verifier
                        </Link>) : (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit2}>
                          Oui, retirer
                        </Link>)
                    }
                  </>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-check" />
                </span>
                <h4>Verifier le compte</h4>
                <p>
                  {selectedId?.is_verified === false ?
                    ("Vous souhaitez verifier ce compte.") : ("Vous souhaitez retirer la verification sur ce compte.")}
                </p>
                <div className="d-flex justify-content-center">
                  <>
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Fermer
                    </Link>
                    {
                      selectedId?.is_verified === false ?
                        (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit}>
                          Oui, Verifier
                        </Link>) : (<Link to="#" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSubmit2}>
                          Oui, retirer
                        </Link>)
                    }
                  </>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <div className="modal-header">
          <h4 className="modal-title">View Details</h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body mb-0">
          <div className="parent-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="d-flex align-items-center mb-3">
                  <span className="avatar avatar-xl me-2">
                    <img
                      /*  src={`data:image/png;base64,${parentStudents?.avatar}`} */
                      src={`https://soft.metuaa.com/web/image?model=res.partner&id=${parentStudents?.partner_id}&field=image_1920`}
                      alt="img"
                    />
                  </span>
                  <div className="parent-name">
                    <h5 className="mb-1">{parentStudents?.name}</h5>
                    <p>Added on 25 Mar 2024</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <ul className="d-flex align-items-center">
                  <li className="mb-3 me-5">
                    <p className="mb-1">Email</p>
                    <h6 className="fw-normal">{parentStudents?.email}</h6>
                  </li>
                  <li className="mb-3">
                    <p className="mb-1">Phone</p>
                    <h6 className="fw-normal">{parentStudents?.phone}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <h5 className="mb-3">Children Details</h5>
          {parentStudents?.students && parentStudents?.students.map((item: any, index: any) => (
            <div className="border rounded p-4 pb-1 mb-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap pb-1 mb-3 border-bottom">
                <span className="link-primary mb-2">RFID</span>
                {item?.active ? (
                  <span className="badge badge-soft-success badge-md mb-2">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Active
                  </span>
                ) : (
                  <span className="badge badge-soft-danger badge-md mb-2">
                    <i className="ti ti-circle-filled fs-5 me-1" />
                    Inactive
                  </span>
                )
                }


              </div>
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="d-flex align-items-center mb-3">
                  <Link to={routes.studentDetail} className="avatar">
                    <img
                      /*             src={`data:image/png;base64,${item?.avatar}`} */
                      src={`https://soft.metuaa.com/web/image?model=op.student&id=${item?.id}&field=image_1920`}
                      className="img-fluid rounded-circle"
                      alt="img"
                    />
                  </Link>
                  <div className="ms-2">
                    <p className="mb-0">
                      <Link to={routes.studentDetail}>{item?.first_name} {item?.last_name}</Link>
                    </p>
                    <span>III, A</span>
                  </div>
                </div>
                <ul className="d-flex align-items-center flex-wrap">

                  <li className="mb-3 me-4">
                    <p className="mb-1">Gender</p>
                    <h6 className="fw-normal">{item?.gender === "f" ? "Female" : "Male"}</h6>
                  </li>

                </ul>
                <div className="d-flex align-items-center">
                  <Link to="#" className="btn btn-light mb-3 me-3">
                    Add Fees
                  </Link>
                  <a
                    onClick={() => navigeStudentDetails(item)}
                    className="btn btn-primary mb-3"
                  >
                    View Details
                  </a>
                </div>
              </div>
            </div>
          ))}

        </div>
      </Modal>


      <Modal show={showModal0} onHide={handleClose0} >
        <Modal.Header >
          <Modal.Title>Add Student</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose0}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                      onChange={handleInputChange} />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email"
                      value={formData.email}
                      onChange={handleInputChange} placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input type="number" className="form-control" name="phone" value={formData.phone} placeholder="Phone"
                      onChange={handleInputChange} />

                  </div>


                  <div className="mb-3">
                    <label className="form-label">
                      Relationship
                    </label>

                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={handleInputChange}
                      name="relationship_id"
                    >
                      <option >Choisir</option>
                      {
                        relationShips && relationShips?.map(item => (
                          <option value={item.id}>{item?.name}</option>
                        ))
                      }

                    </select>

                  </div>


                  <div className="mb-3">
                    <label className="form-label">Student(s)</label>
                    <Select
                      classNamePrefix="react-select"
                      options={students}
                      className="js-example-placeholder-multiple select2 js-states"
                      isMulti={true}
                      name="students_ids"
                      onChange={handleSelectChange}
                      placeholder="Select"
                    />
                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose0}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary"  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Add Parent"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Modal show={showModal2} onHide={handleClose2} >
        <Modal.Header >
          <Modal.Title>Edit Parent</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose2}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord.name}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control" name="email"
                      value={selectedRecord.email}
                      placeholder="Email" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Phone</label>
                    <input type="number" className="form-control" name="phone" value={selectedRecord.phone} placeholder="Phone"
                    />

                  </div>


                  <div className="mb-3">
                    <label className="form-label">
                      Relationship
                    </label>

                    <select
                      className="form-select"
                      aria-label="Default select example"

                      value={selectedRecord.relationship_id.id}
                      name="relationship_id"
                    >
                      <option >Choisir</option>
                      {
                        relationShips && relationShips?.map(item => (
                          <option value={item.id}>{item?.name}</option>
                        ))
                      }

                    </select>

                  </div>


                  <div className="mb-3">
                    <label className="form-label">Student(s)</label>
                    <Select
                      classNamePrefix="react-select"
                      options={students}
                      className="js-example-placeholder-multiple select2 js-states"
                      isMulti={true}
                      name="students_ids"

                      placeholder="Select"
                      defaultValue={multiSubject}
                    />
                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose0}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary"  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Edit Parent"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>


    </>
  );
};

export default ParentGrid;
